module.exports = __webpack_public_path__ + "static/img/23.8186f709.png";